// Per-product and per-category SEO metadata.
// Titles ≤ 65 chars, descriptions 140–160 chars, all unique and technical.

export const productSEO = {
  // Rotating Equipment Guards
  'belt-chain-gear-drive-guards': {
    title: 'Belt, Chain & Gear Drive Guards | Stallion Bulktech',
    description:
      '360° zero-contact guards for belt, chain, and gear drives on rotating equipment. Engineered for high-load mining, cement, and power plant operations.',
  },
  'compressor-pump-guards': {
    title: 'Compressor & Pump Guards | Stallion Bulktech',
    description:
      'Safety guards for air compressors and process pumps with easy maintenance access. Protect rotating components in chemical, pharma, and utility plants.',
  },
  'coupling-guards': {
    title: 'Coupling Guards for Rotating Shafts | Stallion Bulktech',
    description:
      'Full enclosure guards for flexible and rigid couplings on rotating shafts. Prevent entanglement injuries in power, pump, and blower installations.',
  },
  'flange-bearing-guards': {
    title: 'Flange Bearing Guards for Industrial Motors | Stallion Bulktech',
    description:
      'Precision guards for flange-mounted bearings. Reduce exposure to rotating shaft ends and simplify grease-line access in pump and fan installations.',
  },
  'pump-gland-guards': {
    title: 'Pump Gland Guards for Sealing Areas | Stallion Bulktech',
    description:
      'Protective guards for pump gland and seal areas. Contain fluid leaks and shield operators during routine maintenance in chemical and refinery plants.',
  },

  // Conveyor Guards
  'conveyor-side-guards': {
    title: 'Conveyor Side Guards for Bulk Handling | Stallion Bulktech',
    description:
      'Side-mounted conveyor guards that prevent personnel contact and contain material spillage at transfer points in mining, cement, and steel plants.',
  },
  'pulley-guards': {
    title: 'Pulley Guards for Conveyor Systems | Stallion Bulktech',
    description:
      'Enclosure guards for conveyor head, drive, and tail pulleys. Prevent entanglement at rotating pulley zones in mining and cement operations.',
  },
  'return-idler-guards': {
    title: 'Return Idler Guards for Conveyor Belts | Stallion Bulktech',
    description:
      'Return idler roller guards for bulk conveyors. Block access to pinch points and reduce material carry-back incidents across cement and mining plants.',
  },
  'conveyor-canopy': {
    title: 'Conveyor Canopy Covers for Outdoor Belts | Stallion Bulktech',
    description:
      'Modular canopy covers for outdoor conveyor belts. Shield material from rain, wind, and sun in mining, cement, and port handling operations.',
  },

  // Perimeter Barrier Guards
  'workstation-barrier-guards': {
    title: 'Workstation Barrier Guards for Factory Floors | Stallion Bulktech',
    description:
      'Modular barrier guards that segregate operator workstations from moving equipment. Deployed in automotive, fabrication, and packaging lines.',
  },
  'safety-fencing': {
    title: 'Industrial Safety Fencing for Machine Zones | Stallion Bulktech',
    description:
      'Perimeter safety fencing for robotic cells, conveyor lines, and hazardous equipment zones. Panel-based, quick-assembly fencing for plant layouts.',
  },
  'modular-handrails': {
    title: 'Modular Handrails for Platforms & Walkways | Stallion Bulktech',
    description:
      'Bolt-together modular handrail systems for industrial platforms, stairs, and walkways. Compliant fall protection for cement, steel, and process plants.',
  },

  // Workshop Machine Guards
  'lathe-machine-guards': {
    title: 'Lathe Machine Guards for Chuck Zones | Stallion Bulktech',
    description:
      'Polycarbonate-front lathe guards for chuck and carriage protection. Stop chip ejection and coolant spray during turning operations in machine shops.',
  },
  'drill-machine-guards': {
    title: 'Drill Machine Guards for Pillar Drills | Stallion Bulktech',
    description:
      'Interlocked spindle guards for pillar and bench drills. Prevent swarf ejection and accidental contact during drilling and tapping operations.',
  },
  'milling-machine-guards': {
    title: 'Milling Machine Guards for CNC & Manual Mills | Stallion Bulktech',
    description:
      'Full-enclosure milling guards for CNC and manual machines. Contain cutter debris and coolant while maintaining operator visibility in machine shops.',
  },

  // Smart Guards
  'smart-guards-with-interlocks': {
    title: 'Smart Safety Guards with Interlocks | Stallion Bulktech',
    description:
      'Machine guards integrated with safety interlocks for automated shutdown on door open. Used on high-speed equipment in automotive and packaging lines.',
  },

  // Modular Rain Guards
  'foot-mounted-motor-guards': {
    title: 'Foot Mounted Motor Guards for Outdoor Drives | Stallion Bulktech',
    description:
      'Rain-resistant covers for foot-mounted industrial motors exposed to outdoor weather. Reduce corrosion and unplanned motor failures in open plants.',
  },
  'flange-mounted-motor-guards': {
    title: 'Flange Mounted Motor Guards | Stallion Bulktech',
    description:
      'Weatherproof rain guards for flange-mounted motors on vertical and side drives. Shield bearing housings from rain ingress in outdoor installations.',
  },

  // Dust Suppression System
  'wind-fence': {
    title: 'Wind Fence for Coal & Stockyard Dust Control | Stallion Bulktech',
    description:
      'Porous wind fencing around coal yards and open stockpiles. Reduces wind-driven dust emissions and material loss at mining, cement, and power sites.',
  },
  'dry-fog': {
    title: 'Dry Fog Dust Suppression for Transfer Points | Stallion Bulktech',
    description:
      'Dry fog systems deliver ultra-fine mist at conveyor transfer points and crusher outputs. Suppress airborne dust without wetting the material handled.',
  },
  'high-pressure-mist': {
    title: 'High Pressure Mist Systems for Dust Control | Stallion Bulktech',
    description:
      'High-pressure mist nozzles for wide-area dust suppression in crushing, screening, and bulk handling zones. Improve plant visibility and air quality.',
  },

  // Wear Resistance
  'ceramic-tiles-high-aluminium-liners': {
    title: 'High Alumina Ceramic Liners for Chutes | Stallion Bulktech',
    description:
      '92-95% alumina ceramic tiles for lining chutes, hoppers, and transfer points. Withstand heavy abrasion in mining, cement, and steel plant operations.',
  },
  'ceramic-pulley-lagging': {
    title: 'Ceramic Pulley Lagging for Conveyor Drives | Stallion Bulktech',
    description:
      'Ceramic-insert rubber lagging for conveyor drive pulleys. Prevents belt slippage in wet conditions and extends pulley and belt service life.',
  },
  'ceramic-pad-lagging': {
    title: 'Ceramic Pad Lagging for Non-Drive Pulleys | Stallion Bulktech',
    description:
      'Bolt-on ceramic pad lagging for non-drive and snub pulleys. Wear-resistant pads reduce pulley replacement frequency in high-load bulk conveyors.',
  },
};

// Category-level SEO (used on /products?category=X landing views).
export const categorySEO = {
  'Conveyor Guards': {
    title: 'Conveyor Guards for Bulk Material Handling | Stallion Bulktech',
    description:
      'Heavy-duty conveyor guarding systems for mining, cement, and bulk handling plants. Protect personnel at transfer points and reduce operational risk.',
  },
  'Rotating Equipment Guards': {
    title: 'Rotating Equipment Guards for Heavy Plants | Stallion Bulktech',
    description:
      '360° guarding for belts, chains, couplings, and bearings on rotating equipment. Reduce maintenance exposure and downtime in high-load industries.',
  },
  'Perimeter Barrier Guards': {
    title: 'Perimeter Barrier Guards for Plant Safety | Stallion Bulktech',
    description:
      'Modular perimeter guarding for equipment cells, workstations, and hazardous zones. Control access in mining, cement, and manufacturing facilities.',
  },
  'Workshop Machine Guards': {
    title: 'Workshop Machine Guards for Lathes & Mills | Stallion Bulktech',
    description:
      'Protective guards for workshop machinery including lathes, drills, and milling machines. Operator-safe designs with clear sight-lines and quick access.',
  },
  'Modular Rain Guards': {
    title: 'Modular Rain Guards for Outdoor Motors | Stallion Bulktech',
    description:
      'Weather-resistant rain guards for foot and flange-mounted motors installed outdoors. Extend motor life in cement, power, and bulk handling plants.',
  },
  'Dust Suppression System': {
    title: 'Dust Suppression Systems for Bulk Handling | Stallion Bulktech',
    description:
      'Wind fence, dry fog, and high-pressure mist dust suppression for conveyors, crushers, and stockpiles. Cut airborne dust at source in mining and cement.',
  },
  'Wear Resistance': {
    title: 'Wear Resistance Solutions for Chutes & Liners | Stallion Bulktech',
    description:
      'Ceramic wear liners and pulley lagging for chutes, hoppers, and transfer points. Extend component life and reduce replacement frequency in bulk plants.',
  },
};
